'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.calculateQuadraticControlPoint = exports.rectBezierIntersection = exports.rectControlPointWithinRectIntersection = exports.findControlPointWithinRectSideIntersection = exports.rectCurvedBezierIntersection = exports.findCurveSideIntersection = undefined;

var _bezierJs = require('bezier-js');

var _bezierJs2 = _interopRequireDefault(_bezierJs);

var _lodash = require('lodash');

var _intersection = require('./intersection');

var _rect = require('./rect');

var rectLib = _interopRequireWildcard(_rect);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Make the bezier 't' value (ratio at which it sits along the line) halfway along the line


// Geometry
// Lib
var DEFAULT_BEZIER_T = 0.5;
var MAX_INTERSECTION_ATTEMPTS = 5;

var findCurveSideIntersection = exports.findCurveSideIntersection = function findCurveSideIntersection(_ref) {
    var side = _ref.side,
        bezier = _ref.bezier;

    var intersections = bezier.intersects({ p1: side.start, p2: side.end });
    if (!intersections.length) return;

    // Sort and then pick the first intersection because it will be closer to the origin of the line
    intersections.sort();
    return intersections[0];
};

var rectCurvedBezierIntersection = exports.rectCurvedBezierIntersection = function rectCurvedBezierIntersection(_ref2) {
    var sides = _ref2.sides,
        bezier = _ref2.bezier;

    var intersection = (0, _lodash.reduce)(sides, function (accIntersection, side) {
        var newIntersection = findCurveSideIntersection({ side: side, bezier: bezier });
        return !accIntersection || newIntersection < accIntersection ? newIntersection : accIntersection;
    }, null);
    return intersection ? bezier.get(intersection) : undefined;
};

var findLinearSideIntersection = function findLinearSideIntersection(_ref3) {
    var side = _ref3.side,
        bezier = _ref3.bezier;
    return (0, _intersection.lineIntersectionPoints)(side.start, side.end, bezier.points[0], bezier.points[2]);
};

var rectLinearBezierIntersection = function rectLinearBezierIntersection(_ref4) {
    var sides = _ref4.sides,
        bezier = _ref4.bezier;
    return (0, _lodash.reduce)(sides, function (intersection, side) {
        return intersection || findLinearSideIntersection({ side: side, bezier: bezier });
    }, null);
};

var findControlPointWithinRectSideIntersection = exports.findControlPointWithinRectSideIntersection = function findControlPointWithinRectSideIntersection(_ref5) {
    var side = _ref5.side,
        controlPoint = _ref5.controlPoint,
        targetPoint = _ref5.targetPoint;
    return (0, _intersection.lineIntersectionPoints)(side.start, side.end, controlPoint, targetPoint);
};

var rectControlPointWithinRectIntersection = exports.rectControlPointWithinRectIntersection = function rectControlPointWithinRectIntersection(_ref6) {
    var sides = _ref6.sides,
        controlPoint = _ref6.controlPoint,
        targetPoint = _ref6.targetPoint;
    return (0, _lodash.reduce)(sides, function (intersection, side) {
        return intersection || findControlPointWithinRectSideIntersection({ side: side, controlPoint: controlPoint, targetPoint: targetPoint });
    }, null);
};

/**
 * Finds the point at which the bezier curve (made from the bezier points provided) intersects the rectangle.
 * If it intersects at many points
 */
var rectBezierIntersection = exports.rectBezierIntersection = function rectBezierIntersection(rect, _ref7) {
    var sourcePoint = _ref7.sourcePoint,
        controlPoint = _ref7.controlPoint,
        targetPoint = _ref7.targetPoint;
    var attempt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    var sides = rectLib.getSides(rect);
    if (rectLib.containsPoint(rect, controlPoint)) {
        return rectControlPointWithinRectIntersection({ sides: sides, controlPoint: controlPoint, targetPoint: targetPoint });
    }

    var bezier = _bezierJs2.default.quadraticFromPoints(sourcePoint, controlPoint, targetPoint, DEFAULT_BEZIER_T);

    if (bezier._linear) return rectLinearBezierIntersection({ sides: sides, bezier: bezier });

    // Try to find the intersection using the Bezier library
    var intersection = rectCurvedBezierIntersection({ sides: sides, bezier: bezier });

    // Unfortunately the Bezier library suffers some Math rounding errors, as such if an intersection can't be
    // found we retry with a slightly different target point in the hope that the rounding error doesn't occur.
    // If we retry 5 times and we still don't have an intersection then we just finish (I think that would be
    // pretty unlikely).
    if (intersection || attempt >= MAX_INTERSECTION_ATTEMPTS) return intersection;

    return rectBezierIntersection(rect, {
        sourcePoint: sourcePoint,
        controlPoint: controlPoint,
        targetPoint: {
            x: attempt % 2 ? targetPoint.x + 1 : targetPoint.x,
            y: attempt % 2 ? targetPoint.y : targetPoint.y + 1
        }
    }, attempt + 1);
};

/**
 * http://stackoverflow.com/questions/9710616/explain-formula-to-curve-through-a-control-point
 */
var quadraticControlPointFormula = function quadraticControlPointFormula(dimension) {
    return function (start, end, lineControlPoint, ratio) {
        return (lineControlPoint[dimension] - Math.pow(1 - ratio, 2) * start[dimension] - Math.pow(ratio, 2) * end[dimension]) / (2 * ratio * (1 - ratio));
    };
};
var quadraticControlPointFormulaX = quadraticControlPointFormula('x');
var quadraticControlPointFormulaY = quadraticControlPointFormula('y');

var calculateQuadraticControlPoint = exports.calculateQuadraticControlPoint = function calculateQuadraticControlPoint(start, end, lineControlPoint) {
    var ratio = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.5;
    return {
        x: quadraticControlPointFormulaX(start, end, lineControlPoint, ratio),
        y: quadraticControlPointFormulaY(start, end, lineControlPoint, ratio)
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/common/maths/geometry/bezierUtil.js
// module id = 795
// module chunks = 0